import React, { useEffect, useState } from "react";
import { Box, styled, Typography, useTheme } from "@mui/material";
import { CenteredSiteBlock } from "../../routes/Home";
import { useIsMobile } from "../../hooks/responsive";
import logoImage from "../../resources/images/svg/inexplore-logo-white.svg";

import { ReactComponent as facebookIcon } from "../../resources/images/svg/home/socials/facebook.svg";
import { ReactComponent as instagramIcon } from "../../resources/images/svg/home/socials/instagram.svg";
import { ReactComponent as podcastIcon } from "../../resources/images/svg/home/socials/podcast.svg";
import { ReactComponent as rssIcon } from "../../resources/images/svg/home/socials/rss.svg";
import { ReactComponent as telegramIcon } from "../../resources/images/svg/home/socials/telegram.svg";
import { ReactComponent as tiktokIcon } from "../../resources/images/svg/home/socials/tiktok.svg";
import { ReactComponent as xIcon } from "../../resources/images/svg/home/socials/x.svg";
import { ReactComponent as youtubeIcon } from "../../resources/images/svg/home/socials/youtube.svg";
import { useGetFooterQuery } from "../../store/api/footer";

const Container = styled(Box)(({ theme }) => {
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    width: "100%",
    minHeight: "100px",
    background:
      "linear-gradient(90.74deg, rgba(5, 150, 161, 0.2) 0.82%, rgba(57, 113, 246, 0.2) 19.84%, rgba(154, 69, 244, 0.2) 41.65%, rgba(252, 125, 6, 0.2) 60.21%, rgba(247, 225, 68, 0.2) 78.76%, rgba(255, 70, 38, 0.2) 97.32%)",
    position: "relative",
  };
});

const items = [
  {
    title: "Instagram",
    icon: instagramIcon,
    picto: "https://medias.inrees.com/img/pictos/instagram.svg",
    link: "https://www.instagram.com/inexplore_praticiens/",
  },
  {
    title: "Youtube",
    icon: youtubeIcon,
    picto: "https://medias.inrees.com/img/pictos/youtube.svg",
    link: "https://www.youtube.com/@inexplore_praticiens",
  },
  {
    title: "Facebook",
    icon: facebookIcon,
    picto: "https://medias.inrees.com/img/pictos/facebook.svg",
    link: "https://www.facebook.com/profile.php?id=61582157365868",
  },
  /*{
    title: "Telegram",
    icon: telegramIcon,
    link: "https://www.instagram.com",
  },
  {
    title: "X",
    icon: xIcon,
    link: "https://www.instagram.com",
  },
  {
    title: "Tiktok",
    icon: tiktokIcon,
    link: "https://www.instagram.com",
  },
  {
    title: "Podcast",
    icon: podcastIcon,
    link: "https://www.instagram.com",
  },
  {
    title: "RSS",
    icon: rssIcon,
  },*/
];

const SocialItem = ({ item }) => {
  return (
    <a
      className={"social-link"}
      href={item.link}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <img
        src={item.picto}
        className="icon"
        alt={item.title}
        style={{
          width: "25px",
          height: "25px",
        }}
      />
      <Typography
        sx={{
          mt: 1,
          fontWeight: 500,
          fontSize: "15px",
        }}
      >
        {item.title}
      </Typography>
    </a>
  );
};

const Socials = () => {
  const isMobile = useIsMobile();

  const [footer, setFooter] = useState(null);
  const { data, isFetching } = useGetFooterQuery();

  useEffect(() => {
    // TODO : call /footer in the API with a fetch or a RTK Query.
    if (data) {
      setFooter(data.footer);
    }
  }, [data]);

  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        backgroundColor: (theme) => theme.palette.blackPro,
      }}
    >
      <Container className={"develop-alliances"}>
        <CenteredSiteBlock
          sx={{
            position: "relative",
            backgroundRepeat: "no-repeat",
            backgroundSize: "stretch",
            backgroundPosition: "top",
            marginTop: (theme) => theme.spacing(isMobile ? 5 : 10),
            marginBottom: (theme) => theme.spacing(isMobile ? 5 : 10),
            display: "flex",
            flexDirection: "column",
            paddingLeft: "20px",
            paddingRight: "20px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              alignItems: "center",
            }}
          >
            <Typography
              variant="h2"
              component="h2"
              sx={{
                color: "white",
                fontSize: "20px",
                margin: 0,
              }}
            >
              Suivez nous sur nos réseaux dédiés
            </Typography>
            <img
              src={logoImage}
              alt={"site logo"}
              style={{ maxHeight: "30px", marginLeft: "10px" }}
            />
          </Box>

          <Box
            sx={{
              mt: 5,
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              gap: "50px",
              justifyContent: "space-between",
            }}
          >
            {items?.map((item, index) => (
              <SocialItem item={item} key={index} />
            ))}
          </Box>
        </CenteredSiteBlock>
      </Container>
    </Box>
  );
};

export default Socials;
